import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from './auth.service';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable()
export class CustomerValidationService {

    constructor(private _httpClient: HttpClient, private _authService: AuthService) { }

    getCiudadCodPostal(codPostal: number | string): Observable<any> {
        return this._httpClient.post(`${environment.ENTORNO}Services/General/PostalCodesService.svc/GetByCapCode`,
            {searchValue: codPostal, isoCode: this._authService.getDataPais().toUpperCase()}).pipe(
            map((data: any) => data.contents.length > 0 ? data.contents[0] : null)
        );
    }

    // Devuelve verdadero si es codigo valido
    isValidFiscalCode(fiscalCode: string): Observable<boolean> {
        return this._httpClient.post(`${environment.ENTORNO}Services/General/CustomerService.svc/ValidateFiscalCode`,
            {fiscalCode}).pipe(
            map((data: any) => data.Response.IsValid)
        );
    }

    // Devuelve verdadero si es codigo duplicado
    isDuplicateFiscalCode(fiscalCode: string): Observable<boolean> {
        return this._httpClient.post(`${environment.ENTORNO}Services/General/CustomerService.svc/ExistsByFiscalCode`,
            {searchValue: fiscalCode}).pipe(
            map((data: any) => data.Response.Data)
        );
    }

    // Devuelve verdadero si se puede editar el codigo fiscal del cliente
    canUpdateFiscalCode(customerCode: string): Observable<boolean> {
        return this._httpClient.post(`${environment.ENTORNO}Services/General/CustomerService.svc/CanUpdateFiscalCodeByCustomerCode`,
            {customerCode}).pipe(
                map((data: any) => data.Response.Data)
        );
    }

    // Devuelve verdadero si se puede editar la informacion de direccion del cliente
    canUpdateCustomerAddress(customerCode: string): Observable<boolean> {
        return this._httpClient.post(`${environment.ENTORNO}Services/General/CustomerService.svc/CanUpdateCompleteAddressByCustomerCode`,
            {customerCode}).pipe(
                map((data: any) => data.Response.Data)
        );
    }
}
